import React from "react";
import {Modal, Button} from "antd";

const NoAutorizado = () => {
    return <h1>Usuario no autorizado</h1>;
};

export default NoAutorizado;
